import React, {PropTypes} from 'react';
import Display from '../parts/display';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as siteActions from '../../actions/siteActions';
import { ScrollToPlugin } from 'gsap';
import ClientsBlock from '../clientsBlock';
import BlogBlock from '../blogBlock';
import GoogleMap from 'google-map-react';
import is from 'is_js';


function createMapOptions(maps) {
    let drgflag = true;

    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        drgflag = false;
    }
    return {
        zoomControlOptions: {
            position: maps.ControlPosition.RIGHT_CENTER,
            style: maps.ZoomControlStyle.SMALL
        },
        mapTypeControlOptions: {
            position: maps.ControlPosition.TOP_RIGHT
        },
        draggable: drgflag,
        mapTypeControl: true,
        scrollwheel:  false,
        styles: [{"featureType":"administrative","elementType":"labels.text.fill","stylers":[{"color":"#63686b"}]},{"featureType":"landscape","elementType":"all","stylers":[{"color":"#f6f6f6"}]},{"featureType":"poi","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"road","elementType":"all","stylers":[{"saturation":-100},{"lightness":45}]},{"featureType":"road.highway","elementType":"all","stylers":[{"visibility":"simplified"}]},{"featureType":"road.arterial","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"transit","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"water","elementType":"all","stylers":[{"color":"#281E78"},{"visibility":"on"}]}]
    };
}

class ContactPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            name: '',
            job: '',
            company: '',
            email: '',
            phone: '',
            enquiry: '',
            validation: [],
            message: false
        };
        this.send = this.send.bind(this);
        this.updateField = this.updateField.bind(this);
    }
    componentWillMount(){
        window.scrollTo(0,0);
    }
    componentDidMount() {
        var _this = this;
        this.props.actions.showNavBar(true);
        this.props.actions.showMenu(true);

        if(this.props.site.posts.length < 4){
            this.props.actions.loadBlogPosts(3,1);
        }
    }
    updateField(e){
        this.setState({
            [e.target.name]: e.target.value
        });
    }
    componentWillReceiveProps(nextProps){
        if(this.props.site.sentEnquiry !== nextProps.site.sentEnquiry){
            this.setState({
                message: 'Thank you for your enquiry, we will be in touch very soon.',
                name: '',
                job: '',
                company: '',
                email: '',
                phone: '',
                enquiry: ''
            });
        }
    }
    send(){
        let validation = [];
        this.setState({
            validation: validation
        }, ()=>{
            if(this.state.name.length < 1){
                validation = validation.concat(['Please add your name']);
            }
            if(this.state.email.length < 1 || !is.email(this.state.email)){
                validation = validation.concat(['Please add a valid email address']);
            }
            if(this.state.enquiry.length < 1){
                validation = validation.concat(['Please write your enquiry']);
            }

            this.setState({
                validation: validation
            },()=>{
                if(this.state.validation.length < 1){
                    this.props.actions.sendEnquiry({
                        input_values:{
                            input_1: this.state.name,
                            input_2: this.state.job,
                            input_3: this.state.company,
                            input_4: this.state.email,
                            input_5: this.state.phone,
                            input_6: this.state.enquiry,
                        }
                    });
                }
            })
        });
    }
    render() {
        return (
            <div className="services-page animated fadeIn portfolio-page contact-page">
                <div className="portfolio-top">
                    <div className="container">
                        <div className="row">
                            <h1><span>/</span> Contact</h1>
                            <div className="dash-separator"></div>
                            <h3>Details</h3>
                            <div className="contact-details">
                                <p>Indigo Multimedia <br />
                                    176 New Bridge Street<br />
                                    Newcastle upon Tyne<br />
                                    NE1 2TE<br />
                                    <br />
                                </p>
                                <p>
                                    <a href="mailto: info@indigomultimedia.com">e: info@indigomultimedia.com</a><br />
                                    <a href="tel: +441912092100">t: 0191 209 2100</a><br /><br />
                                    <span className="small">Company Reg No: 03114121</span>
                                    <span className="small">VAT No: 633694323</span>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="page-content">

                    <div className="container">
                        <div className="row">
                            <h3>Location</h3>
                            <div className="google-map">
                                <div className="map-overlay"></div>
                                <GoogleMap
                                    apiKey={"AIzaSyAQzIOg7lGXWXvpAKR67viTurLOyfqarBg"}
                                    center={[54.974385, -1.601596]}
                                    zoom={13}
                                    options={createMapOptions}
                                >
                                    <div lat={54.974385} lng={-1.601596}  className="marker">
                                        /
                                        <div className="inside"></div>
                                    </div>
                                </GoogleMap>
                            </div>

                        </div>
                    </div>
                </div>
                <div className="enquiries-form">
                    <div className="container">
                        <div className="row">
                            <h3>Enquiries</h3>
                            <p>Please get in touch via the form below.</p>
                            <form className="form">
                                <div className="form-control">
                                    <input type="text" placeholder="Name" name="name" onChange={this.updateField} value={this.state.name} />
                                </div>
                                <div className="form-control">
                                    <input type="text" placeholder="Job Title" name="job" onChange={this.updateField} value={this.state.job} />
                                </div>
                                <div className="form-control">
                                    <input type="text" placeholder="Company" name="company" onChange={this.updateField} value={this.state.company} />
                                </div>
                                <div className="form-control">
                                    <input type="email" placeholder="Email" name="email" onChange={this.updateField} value={this.state.email} />
                                </div>
                                <div className="form-control">
                                    <input type="tel" placeholder="Telephone" name="phone" onChange={this.updateField} value={this.state.phone} />
                                </div>
                                <div className="form-control">
                                    <textarea type="text" placeholder="Enquiry" cols="6" name="enquiry" onChange={this.updateField} value={this.state.enquiry} />
                                </div>
                                <Display if={this.state.validation.length > 0} className="validation">
                                    {this.state.validation.map((val, i)=>{
                                        return <p key={i}>{val}</p>;
                                    })}
                                </Display>
                                <Display if={this.state.message} className="message">
                                    {this.state.message}
                                </Display>
                                <Display if={!this.state.message}>
                                    <div className="form-control">
                                        <div type="submit" name="sumbit" className="btn" onClick={this.props.site.sendingEnquiry? null: this.send}>{this.props.site.sendingEnquiry? "Sending..." : "Submit"}</div>
                                    </div>
                                </Display>
                            </form>
                        </div>
                    </div>
                </div>
                <ClientsBlock clients={this.props.site.selectedClients} />
                <BlogBlock posts={this.props.site.posts} maxPosts={3} loading={this.props.site.loadingPosts} />
            </div>
        );
    }
}

ContactPage.defaultProps = {

};

function mapStateToProps(state, ownProps) {
    return {
        site: state.site
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(siteActions, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ContactPage);



/** WEBPACK FOOTER **
 ** ./src/js/components/contact/contactPage.js
 **/